/** Inline SVG */
SVGInject(document.querySelectorAll("img.inline-svg"));

/** Customize vh property (fixing mobile problems) */
window.addEventListener(
  "resize",
  () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  },
  { passive: true }
);
window.addEventListener(
  "resize",
  () => {
    let vw = window.innerWidth * 0.01;
    document.documentElement.style.setProperty("--vw", `${vw}px`);
  },
  { passive: true }
);
